<template>
  <div class="club_square_page">
    <div class="club_square_content">
      <div class="club_square_header">
        <div class="club_square_title">{{ $t("clubSquare.pageTitle") }}</div>
      </div>

      <div class="club_square_banner">
        <div class="club_square_banner_text">
          <div class="club_square_banner_title">{{ $t("clubSquare.bannerTitle") }}</div>
          <div class="club_square_banner_subtitle">{{ $t("clubSquare.bannerSubtitle") }}</div>
        </div>
        <div class="club_square_banner_image" :style="bannerStyle"></div>
      </div>

      <div class="club_square_feed_card">
        <div class="club_square_locked_media" :style="lockedMediaStyle">
          <div class="club_square_locked_overlay">
            <div class="club_square_lock_icon">
              <svg viewBox="0 0 64 64" focusable="false">
                <path d="M44 25h-2v-5a10 10 0 1 0-20 0v5h-2a6 6 0 0 0-6 6v16a6 6 0 0 0 6 6h24a6 6 0 0 0 6-6V31a6 6 0 0 0-6-6Zm-18-5a6 6 0 0 1 12 0v5H26v-5Zm6 22a4 4 0 0 1-2-7.46V32h4v2.54A4 4 0 0 1 32 42Z" fill="currentColor" />
              </svg>
            </div>
            <div class="club_square_locked_title">{{ $t("clubSquare.lockTitle") }}</div>
            <div class="club_square_locked_desc">{{ $t("clubSquare.lockDesc") }}</div>
            <button type="button" class="club_square_verify_button" @click="goVerify">
              {{ $t("clubSquare.verifyButton") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const {
  CLUB_SQUARE_BANNER_IMAGE,
  CLUB_SQUARE_LOCKED_IMAGE,
} = require("./content");

export default {
  name: "ClubSquarePage",
  computed: {
    bannerStyle() {
      return {
        backgroundImage: `url('${CLUB_SQUARE_BANNER_IMAGE}')`,
      };
    },
    lockedMediaStyle() {
      return {
        backgroundImage: `url('${CLUB_SQUARE_LOCKED_IMAGE}')`,
      };
    },
  },
  methods: {
    goVerify() {
      this.$router.push({ path: "/Lottery" });
    },
  },
};
</script>

<style lang="less" scoped>
.club_square_page{
  min-height: 100vh;
  background: #1f1c1f;
  padding: 16px 16px 140px;
}

.club_square_content{
  max-width: 760px;
  margin: 0 auto;
}

.club_square_header{
  margin-bottom: 16px;
  text-align: center;
}

.club_square_title{
  color: #f3c7a2;
  font-size: 34px;
  line-height: 1.2;
  font-weight: bold;
}

.club_square_banner{
  position: relative;
  min-height: 220px;
  border-radius: 24px;
  border: 1px solid rgba(230, 185, 138, 0.24);
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.club_square_banner_image{
  width: 100%;
  min-height: 220px;
  background-color: #29181d;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.club_square_banner_text{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 60%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px 24px 24px 26px;
  background: linear-gradient(90deg, rgba(92, 16, 28, 0.76) 0%, rgba(143, 31, 53, 0.42) 60%, rgba(143, 31, 53, 0) 100%);
}

.club_square_banner_title{
  color: #fff7f5;
  font-size: 38px;
  line-height: 1.2;
  font-weight: bold;
}

.club_square_banner_subtitle{
  margin-top: 12px;
  color: rgba(255, 245, 243, 0.9);
  font-size: 22px;
  line-height: 1.6;
  font-weight: 600;
}

.club_square_feed_card{
  margin-top: 18px;
  min-height: calc(100vh - 420px);
  padding: 0;
  border-radius: 24px;
  border: 1px solid rgba(230, 185, 138, 0.14);
  background: linear-gradient(180deg, #171717 0%, #101010 100%);
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.26);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.club_square_locked_media{
  position: relative;
  min-height: clamp(460px, 58vh, 760px);
  flex: 1;
  background-color: #2c2c2c;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.club_square_locked_media::before{
  content: "";
  position: absolute;
  inset: 0;
  backdrop-filter: blur(3px);
  background: linear-gradient(180deg, rgba(10, 10, 10, 0.18) 0%, rgba(10, 10, 10, 0.28) 100%);
}

.club_square_locked_overlay{
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 24px;
  text-align: center;
}

.club_square_lock_icon{
  width: 112px;
  height: 112px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(240, 198, 157, 0.16);
  color: #ffe8d0;
  box-shadow: inset 0 0 0 1px rgba(240, 198, 157, 0.18);
}

.club_square_lock_icon svg{
  width: 56px;
  height: 56px;
  display: block;
}

.club_square_locked_title{
  margin-top: 20px;
  color: #ffffff;
  font-size: 30px;
  font-weight: bold;
}

.club_square_locked_desc{
  margin-top: 14px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 22px;
  line-height: 1.7;
  max-width: 82%;
}

.club_square_verify_button{
  margin-top: 24px;
  min-width: 230px;
  height: 62px;
  padding: 0 32px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  color: #2c1d10;
  font-size: 26px;
  font-weight: bold;
  box-shadow: 0 12px 26px rgba(220, 171, 118, 0.24);
}

.club_square_stats{
  padding: 18px 20px 20px;
  display: flex;
  align-items: center;
  gap: 26px;
  color: rgba(255, 255, 255, 0.5);
}

.club_square_stat_item{
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
}

.club_square_stat_item svg{
  width: 24px;
  height: 24px;
  display: block;
  color: rgba(255, 129, 150, 0.85);
}
</style>
